<script setup lang="ts">
import { sizes, type IPropSizes } from './styles';

interface Props extends IPropSizes {
  block?: boolean | undefined;
  rounded?: boolean | undefined;
  [x: string]: any;
};

const props = withDefaults(defineProps<Props>(), {
  rounded: true
});

const emit = defineEmits(['click', 'focus']);
</script>

<template>
  <div
    :class="[
      (block ? 'w-full' : 'w-fit'),
      ((size !== undefined) ? sizes[size] : 'padding-auto'),
      (rounded && 'rounded-auto'),
      ('text-auto'),
    ]"
    @click="(e: Event) => ((! disabled) ? emit('click', e) : null)"
    @focus="(e: Event) => ((! disabled) ? emit('focus', e) : null)">
    <slot />
  </div>
</template>
